import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    Container, Image, Modal, Icon, Header, Button
} from 'semantic-ui-react';
import Form from './SignatureForm';
import { actions } from './sagaSlice';
import Dimmer from '+/Dimmer';

const styles = {
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between'
    }
};

const SignatureView = props => {

    const { user, id, readOne } = props;
    const [modalOpen, setModalOpen] = useState(false);
    const [helpModalOpen, setHelpModalOpen] = useState(false);

    useEffect(() => {
        readOne(id);
    }, [id, readOne]);

    if (!user) return <Dimmer />;

    return (
        <Container textAlign='center'>
            <Header>Signature</Header>

            <Modal
                open={modalOpen}
                size='tiny'>

                <Modal.Content>
                    <Form setModalOpen={setModalOpen}/>
                </Modal.Content>
            </Modal>

            <Modal
                open={helpModalOpen}
                size='tiny'>
                <Modal.Header style={styles.modalHeader}>
                    How to create a digital signature
                    <Icon color='red' name='delete' onClick={() => setHelpModalOpen(false)}/>
                </Modal.Header>
                <Modal.Content>
                    Creating a digital signature is easy! Head over to
                    <a href='https://www.docsketch.com/online-signature/draw/' target='_blank' rel='noopener noreferrer'> Doc Sketch </a>
                    and draw your signature using your mouse. Try to keep your signature as close to the bottom of the frame as possible.
                    Once you're done, just click the save button and make sure to toggle the "Transparent background" feature.
                </Modal.Content>
            </Modal>


            {
                user.signature_key
                    ? <Image src={`https://${process.env.REACT_APP_BUCKET_NAME}.s3.amazonaws.com/${user.signature_key}`} size='medium' bordered centered/>
                    : <>
                        <Icon name='picture' size='massive' />
                        <div>
                            <i> No Sigature Found </i>
                        </div>
                    </>
            }

            <Button style={{ marginTop: '20vh' }} onClick={() => setHelpModalOpen(true)}>
                How to create a digital signature
            </Button>

            <Button primary style={{ marginTop: '20vh' }} onClick={() => setModalOpen(true)}>
                Add Signature
            </Button>


        </Container>
    );

};

const mapStateToProps = ({ auth, users }) => ({
    id: auth.id,
    user: users.data[auth.id]
});


export default connect(mapStateToProps, actions)(SignatureView);
